import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const PromotionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ButtonContainer = styled.div`
  width: 15%;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 32px;
  color: ${colors.shades.gamma10};
`;

export {
  PromotionContainer,
  EmptyState,
  ButtonContainer,
};
